import type { WebModule } from "../../core/modules";
import { ConversationsPage } from "./routes/conversations";
import { MessagesPage } from "./routes/messages";
import { ModelesPage } from "./routes/modeles";
import { RappelsPage } from "./routes/rappels";
import { ReglagesPage } from "./routes/reglages";
import { MessagerieWidget } from "./components/home-widget";

// Messagerie PROTECTO : boîte d'envoi (tous), modèles, rappels de suivi et réglages (admin),
// widget d'accueil. Les automatisations vivent côté API.
const messagerie: WebModule = {
  name: "x-messagerie",
  routes: [
    { path: "/messages/conversations", element: <ConversationsPage /> },
    { path: "/messages", element: <MessagesPage /> },
    { path: "/messages/modeles", element: <ModelesPage />, adminOnly: true },
    { path: "/messages/rappels", element: <RappelsPage />, adminOnly: true },
    { path: "/messages/reglages", element: <ReglagesPage />, adminOnly: true },
  ],
  nav: [
    {
      title: "Messagerie",
      items: [
        { to: "/messages/conversations", label: "Conversations", icon: "message", end: true },
        { to: "/messages", label: "Messages", icon: "message", end: true },
        { to: "/messages/modeles", label: "Modèles", icon: "file", end: true, adminOnly: true },
        {
          to: "/messages/rappels",
          label: "Rappels de suivi",
          icon: "clock",
          end: true,
          adminOnly: true,
        },
        { to: "/messages/reglages", label: "Paramètres", icon: "gear", end: true, adminOnly: true },
      ],
    },
  ],
  homeWidgets: [{ id: "messagerie-summary", element: <MessagerieWidget /> }],
};

export default messagerie;
